import axios from "axios";
import { useState, useEffect } from "react";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const baseUrl = process.env.REACT_APP_PUBLIC_API_URL

export default function AgeDistributionChart() {
  const [ageGroups, setAgeGroups] = useState([]);

  useEffect(() => {
    axios.get(`${baseUrl}/demographics`)
      .then(response => {
        const data = response.data;
        if (data.success) {
          setAgeGroups(data.ageGroups);
        }
      })
      .catch(error => console.error("Error fetching age groups:", error));
  }, []);
  return (
    <div
      style={{
        width: "100%",
        // maxWidth: 520,
        height: 350,
        minHeight: 200,
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={ageGroups} margin={{ top: 12, right: 12, left: 8, bottom: 8 }}>
          <XAxis dataKey="label" tick={{ fontSize: 12 }} label={{ value: "Age Group", angle: 2, position: "outsideBottom", dy:15, style: { fontSize: 12} }}/>
          <YAxis
            tick={{ fontSize: 12 }}
            label={{ value: "Number of people", angle: -90, position: "insideLeft", style: { fontSize: 12 } }}
          />
          <Tooltip />
          <Bar dataKey="count" fill="#facc15" radius={[4, 4, 0, 0]} barSize={150}/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
